import { ChecklistItem } from '../bt-checklist-select/checklist';
import { UTOMLANDS } from '../app-place-checklist/placeChecklist';
import { placeLabel } from '../app-place-checklist/placeOptions';

export type CountyMap = Record<string, string[]>;

const COUNTY_PREFIX = 'county:';

export const countyValue = (county: string) => `${COUNTY_PREFIX}${county}`;
const isCountyValue = (value: string) => value.startsWith(COUNTY_PREFIX);

const bySwedishName = (a: string, b: string) => a.localeCompare(b, 'sv');
const abroadLast = (a: string, b: string) =>
  Number(a === UTOMLANDS) - Number(b === UTOMLANDS) || bySwedishName(a, b);

export const countyChecklist = (
  counties: CountyMap,
  countyLabel: (county: string) => string,
): ChecklistItem[] =>
  Object.keys(counties)
    .sort(abroadLast)
    .map(county => {
      const value = countyValue(county);
      if (county === UTOMLANDS) return { value, label: placeLabel(UTOMLANDS) };
      return {
        value,
        label: countyLabel(county),
        options: [...counties[county]]
          .sort(bySwedishName)
          .map(name => ({ value: name, label: name })),
      };
    });

export const splitCountyPicks = (values: readonly string[]) => ({
  county: values.filter(isCountyValue).map(value => value.slice(COUNTY_PREFIX.length)),
  municipality: values.filter(value => !isCountyValue(value)),
});

const COUNTIES_WITHOUT_GENITIVE_S = ['Blekinge', 'Kalmar', 'Skåne', 'Uppsala', 'Örebro'];

export const countyGenitive = (county: string) =>
  COUNTIES_WITHOUT_GENITIVE_S.includes(county) ? county : `${county}s`;
